import { Icon, IconType as AssemblyIconType } from '@assembly-js/design-system';

import { ModuleSettingsItem } from 'src/constants/dataTypes';
import { useGetInstallsQuery } from 'src/services/api/applicationsApi';
import { CoreModule } from 'src/types/modules';

const emptyModules: ModuleSettingsItem[] = [];

export const useModuleIcon = (moduleName: CoreModule) => {
  const { data: settings } = useGetInstallsQuery();
  const modules = settings?.moduleSettings || emptyModules;
  const module = modules.find((m) => m.id === moduleName);

  return (
    <Icon
      icon={(module?.icon as AssemblyIconType) ?? 'dashboard'}
      className="w-6 h-6"
    />
  );
};
